
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repair-pricing/property-investors",
      function () {
        return require("private-next-pages/repair-pricing/property-investors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repair-pricing/property-investors"])
      });
    }
  